var styleDataHash = "94083e5f";
const injectCss = () => {
  var css = `._4eo9K{--wds-list-item-section-padding-horizontal:0px}.Nlai9{width:fit-content}[dir] .Nlai9{box-shadow:0 0 18px rgba(0,6,36,.1),0 6px 6px rgba(0,6,36,.05)}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
};
injectCss();
var design_component_default = {
  "container": "_4eo9K",
  "colorPicker": "Nlai9"
};
export {
  design_component_default as default,
  injectCss
};
//# sourceMappingURL=design-component-scss.js.map
